module.exports = require("@pb/kit-util-generate-padding-classes");